import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { ConfirmationService, SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserService } from 'app/rest/user.service';
import { Rest } from 'app/rest/rest_client';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TaskConstants } from 'app/modules/task/shared/task-constants';
import { Table } from 'primeng/table';
import { Rest_logistics } from 'app/modules/task/Logistics/services/rest_client_logistics';
import User = Rest.User;
import Customer = Rest_logistics.Customer;
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { Directive, EventEmitter, OnDestroy, Output } from '@angular/core';
import NotificationType = Rest_task.NotificationType;
import NotificationParamsMap = Rest_task.NotificationParamsMap;
import NotificationParam = Rest_task.NotificationParam;
import NotificationReceiver = Rest_task.NotificationReceiver;
import Notification = Rest_task.Notification;
import { NotificationService } from 'app/modules/task/administration/services/notification-service';
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
import { LoadingService } from 'app/services/loading-service/loading.service';

@Component({
	selector: 'app-notifications-form',
	templateUrl: './notifications-form.component.html',
	styleUrls: ['./notifications-form.component.css'],
	providers: [NotificationService, TranslateService],
	encapsulation: ViewEncapsulation.None,
})
export class NotificationsFromComponent implements OnInit {
	title: string;
	/*Permissions */
	disableSave: boolean;
	user: User;
	@ViewChild('notificationTypesTable') notificationTypesTable: any;
	//test select primeng
	valiseCodeTableFilters = {};
	//@Input() customer: Customer;
	@Input() isDefault: Boolean;
	@Input() receiverType: NotificationReceiver; //indica el tipus de receiver, pot ser customer, user...
	@Input() receiverId: number;

	mailToolbar = [
		[{ bold: true }, { italic: true }, { underline: true }], // Botones básicos
		[{ align: ['', 'center', 'right', 'justify'] }], // Alineación de texto
		['link', 'image'], // Insertar enlace, imagen, video
		//  [{ 'color': [] }, { 'background': [] }],  // Colores de texto y fondo
		[{ size: ['small', 'medium', 'large', 'huge'] }], // Tamaños de texto
	];

	//filtre per defecte, canvia per cada empresa?
	notificationTypesFilter: NotificationType[] = [
		NotificationType.ORDER_RECEIVED,
		NotificationType.ORDER_CHARGED,
		NotificationType.ORDER_ON_THE_WAY,
		NotificationType.ORDER_DELIVERED,
		NotificationType.ORDER_DELAYED,
		NotificationType.ORDER_NOT_DELIVERED,
	];
	
	notifications: Notification[] = [];
	constructor(
		private notificationService: NotificationService,
		protected i18n: I18nService,
		private authenticationService: AuthenticationService,
		public translate: TranslateService,
		public userService: UserService,
		public confirmationService: ConfirmationService,
		private cdr: ChangeDetectorRef,
		protected notificationsService: NotificationsService,
		public loadingService: LoadingService
	) {}
	ngAfterViewInit() {
		// this.applyCustomFilter();
	}
	ngOnInit() {
		this.user = this.authenticationService.user;
        this.loadFormData();
	}

    loadFormData(){
		let that = this;
		this.loadingService.increaseRESTOngoingRequestCounter();
		Promise.all([this.getNotifications()])
			.catch((error) => {
				console.log(error);
			})
			.finally(() => {
				that.loadingService.decreaseRESTOngoingRequestCounter();
			});
    }

	saveNotification(notification: Notification) {
		notification.id = 0;
		notification = this.setNotificationReceiver(notification);
		if (!this.validateSetNotification(notification)) {
			this.notificationsService.add(
				Severity.error,
				':(',
				this.translate.instant('administration.customers.notification.ErrorNotification') 
			);
			return Promise.reject(this.translate.instant('administration.customers.notification.NoValidValidate'));
		}
		this.loadingService.increaseRESTOngoingRequestCounter();
		let that = this;
		this.notificationService
			.setNotification(notification)
			.then(function (response) {
 				if (response.ok) {
					that.notificationsService.add(Severity.success, ':)', that.translate.instant('administration.customers.notification.UpdateNotification'));
				} else {
					that.notificationsService.add(Severity.error, 'error', that.translate.instant('administration.customers.notification.ErrorNotification'));
				}
			})
			.catch((error) => {
				console.error('Error create saveNotification:', error + '1');
 				that.notificationsService.add(Severity.error, 'error', this.translate.instant('administration.customers.notification.ErrorNotification'));
			}).finally(() => {
				that.loadingService.decreaseRESTOngoingRequestCounter();
			});
	}

	setNotificationReceiver(notification: Notification): Notification {
		if (this.receiverType == NotificationReceiver.CUSTOMER) {
			notification.customer = {} as Rest_logistics.Customer;
			notification.customer.id = this.receiverId;
			notification.isCustomerDefault = this.isDefault;
		}
		notification.receiver = this.receiverType;
		return notification;
	}

	getNotifications():Promise<void> {
		let that = this;
		if (!this.validateGetNotifications()) {
			return Promise.reject(this.translate.instant('administration.customers.notification.noValidGet'));
		}
		const requestBody = {
			receiverId: this.receiverId,
			types: this.notificationTypesFilter, // lista de tipos de notificación
			isDefault: this.isDefault,
			receiver: this.receiverType,
		};
		return this.notificationService
			.getNotifications(requestBody)
			.then(function (response) {
				that.notifications = response;
				that.notifications = that.formatNotificationsParams(that.notifications);
			})
			.catch(function (reason) {
				console.log('Catched: ' + reason);
			});
	}

	formatNotificationsParams(notifications: Notification[]): Notification[] {
		notifications.forEach((notification: Notification) => {
			notification.params = NotificationParamsMap[notification.type];
			console.log(notification.params);
		});
		return notifications;
	}

	validateGetNotifications() {
		if (this.notificationTypesFilter?.length > 0 && this.receiverType != null) {
			return true;
		}
		console.error('validateGetNotifications data failed');
		return false;
	}

	validateSetNotification(notification: Notification) {
		if (
			notification == null ||
			notification.type == null ||
			(notification.notifyBySMS && notification.smsMessage == '') ||
			(notification.notifyByEmail && (notification.mailBody == '' || notification.mailSubject == ''))
		) {
			return false;
		}
		if (this.receiverType == NotificationReceiver.CUSTOMER) {
			if (!notification.isCustomerDefault && (notification.customer == null || notification.customer.id < 1)) {
				return false;
			}
			if (notification.isCustomerDefault && notification.customer?.id > 1) {
				return false;
			}
		}
		return true;
	}
}
